import { render, staticRenderFns } from "./EventsList.vue?vue&type=template&id=2b5de4bc&scoped=true"
import script from "./EventsList.vue?vue&type=script&lang=js"
export * from "./EventsList.vue?vue&type=script&lang=js"
import style0 from "./EventsList.vue?vue&type=style&index=0&id=2b5de4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5de4bc",
  null
  
)

export default component.exports